import type { Map as MapType, MapLayerMouseEvent } from "maplibre-gl";
import type { MapEventBus } from "../core/MapEventBus";
import type { InteractionHandler } from "./types";
import { LAYERS } from "../layers/constants";

export class AircraftClickHandler implements InteractionHandler {
  readonly name = "aircraft-click";
  private map: MapType | null = null;

  initialize(map: MapType, eventBus: MapEventBus): void {
    this.map = map;

    // Click on aircraft
    map.on("click", LAYERS.AIRCRAFT, (e: MapLayerMouseEvent) => {
      e.preventDefault();

      if (!e.features || e.features.length === 0) return;

      const feature = e.features[0];
      const track_id = feature?.properties?.track_id;

      if (track_id) {
        console.log("[AircraftClickHandler] Aircraft clicked:", track_id);

        eventBus.emit("aircraft:clicked", {
          track_id,
          properties: feature.properties,
        });
      }
    });
  }

  destroy(): void {
    // MapLibre automatically removes listeners when map is destroyed
    this.map = null;
  }
}
